import { Flex, HStack, TYPOGRAPHY_COLORS } from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';
import { Nullable } from 'shared_DEPRECATED/types';

import {
  PLANNING_SPRINT_STATE_ICON_MAP,
  SPRINT_STATE_LABELS_WITH_SUB_STATE,
  SPRINT_STATE_UNFINISHED,
} from 'features/planning/config';
import { SPRINT_STATES } from 'features/sprint/config';
import { SprintStateValues } from 'features/sprint/config/types';

import { Typography } from 'shared/components/Typography';

type PlanningSprintHeaderMetadataProps = {
  sprintStateExtended: SprintStateValues | typeof SPRINT_STATE_UNFINISHED.KEY;
  sprintFormattedDate: string;
  durationInWeeks: Nullable<number>;
};

export const PlanningSprintHeaderMetadata = ({
  sprintStateExtended,
  sprintFormattedDate,
  durationInWeeks,
}: PlanningSprintHeaderMetadataProps) => {
  const { bg, color, iconColor } =
    PLANNING_SPRINT_HEADER_STYLES_MAP[sprintStateExtended];

  return (
    <Flex alignItems="center" width="100%" bg={bg} h={9} px={4} gap={2}>
      <HStack gap={0.5}>
        <Icon
          name={PLANNING_SPRINT_STATE_ICON_MAP[sprintStateExtended]}
          fill={iconColor}
          data-testid="sprint-planning-sprint-state-icon"
        />
        <Typography
          color={color as TYPOGRAPHY_COLORS}
          fontWeight="regular"
          type="small"
          data-testid="sprint-planning-sprint-state-label"
        >
          {SPRINT_STATE_LABELS_WITH_SUB_STATE[sprintStateExtended]}
        </Typography>
      </HStack>
      <HStack gap={0.5}>
        <Icon name={iconNames.calendarMonth} fill={iconColor} />
        <Typography
          color={color as TYPOGRAPHY_COLORS}
          fontWeight="regular"
          type="small"
          data-testid="sprint-planning-sprint-dates"
        >
          {sprintFormattedDate}
        </Typography>
      </HStack>
      <HStack gap={0.5}>
        <Icon name={iconNames.hourGlassTop} fill={iconColor} />
        <Typography
          color={color as TYPOGRAPHY_COLORS}
          fontWeight="regular"
          type="small"
          data-testid="sprint-planning-sprint-duration"
        >
          {durationInWeeks} weeks
        </Typography>
      </HStack>
    </Flex>
  );
};

const PLANNING_SPRINT_HEADER_STYLES_MAP: Record<
  SprintStateValues & typeof SPRINT_STATE_UNFINISHED.KEY,
  { bg: string; color: TYPOGRAPHY_COLORS | string; iconColor: string }
> = {
  [SPRINT_STATES.ACTIVE]: {
    color: 'whiteTotal',
    iconColor: 'var(--white)',
    bg: 'var(--bgCompSuccess)',
  },
  [SPRINT_STATES.FINISHED]: {
    color: 'whiteTotal',
    iconColor: 'var(--white)',
    bg: 'var(--bgCompAccent)',
  },
  [SPRINT_STATE_UNFINISHED.KEY]: {
    color: 'var(--fgPrimary)',
    iconColor: 'var(--fgPrimary)',
    bg: 'var(--bgCompSecondaryMid)',
  },
};
